import {DataSource} from "typeorm";
import {createDataSource} from "@/modules/database/services/db";
import {BaseEntity} from "@/modules/base/entity";

export let db: DataSource;

export async function initDataSource(entities: (new () => BaseEntity)[] = []): Promise<DataSource> {
  return db ??= await createDataSource('game', entities);
}